
import { TvProgramByProgDays, TvProgramItem } from '@rtl/api'
import { isAfter } from 'date-fns'
import { Options, Prop, Vue } from 'vue-property-decorator'

import Image from '../Image.vue'
import TvProgramItemCard from './TvProgramItemCard.vue'

@Options({
  name: 'TvProgramCard',
  components: {
    Image,
    TvProgramItemCard
  }
})
export default class TvProgramCard extends Vue {
  @Prop({ type: Object, required: true })
  readonly tvProgram!: TvProgramByProgDays & { name?: string }

  @Prop({ type: Number, default: 3 })
  readonly itemLength!: number

  @Prop({ type: Date })
  readonly firstDate?: Date

  @Prop({ type: Boolean, default: false })
  readonly timeline!: boolean

  get channelLogoUrl (): string | null {
    return this.tvProgram.logoUrl || null
  }

  get items (): TvProgramItem[] {
    if (this.tvProgram?.progDays && this.tvProgram.progDays[0].programs) {
      const items = this.tvProgram.progDays[0].programs || []

      const filteredItems = items.filter(item => {
        const programDate = item.progDate
        const programLength = parseInt(item.progLength || '0')

        if (!programDate) {
          return false
        }

        const programStart = new Date(programDate)
        const programEnd = new Date(programStart).setMinutes(programStart.getMinutes() + programLength)

        return !this.itemLength || isAfter(programStart, new Date()) || isAfter(programEnd, new Date())
      })

      return this.itemLength ? filteredItems.slice(0, this.itemLength) : filteredItems
    }

    return []
  }

  getItemStyleFor (item: TvProgramItem) {
    const getMinutes = (date: Date) => {
      return date.getTime() / 1000 / 60
    }
    return this.timeline && !this.itemLength && item.progDate && this.firstDate ? {
      position: 'absolute',
      top: `${(getMinutes(new Date(item.progDate)) - getMinutes(this.firstDate)) * 5}px`,
      left: 0,
      right: 0
    } : null
  }
}
